const NanLogo = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0141 13.4027V22.635C11.0151 23.0084 11.2456 23.3396 11.5873 23.4589V23.777H8.39444L8.34178 22.5232C7.54132 23.5237 6.32829 24.0695 5.07555 23.993C2.31924 23.993 0.242188 21.7146 0.242188 18.5688C0.242188 15.4231 2.31924 13.1867 5.07555 13.1867C6.32736 13.1155 7.53817 13.6604 8.34178 14.6565L9.09235 13.4027H11.0141ZM3.62927 20.6547C4.13982 21.2158 4.85212 21.5328 5.59672 21.5303V21.5282C6.34379 21.529 7.05862 21.2132 7.57492 20.6543C8.09121 20.0953 8.36395 19.342 8.32969 18.5695C8.36195 17.8024 8.0869 17.0555 7.56953 16.5054C7.05216 15.9552 6.33835 15.6504 5.59672 15.6631C4.85826 15.6497 4.14784 15.9556 3.63646 16.5073C3.12508 17.0589 2.85905 17.8062 2.90241 18.5695C2.85556 19.3387 3.11871 20.0937 3.62927 20.6547Z"
      fill="#F6F3EE"
    />
    <path
      d="M23.669 22.6338V17.1474C23.7281 16.0227 23.3298 14.925 22.5745 14.1308C21.8193 13.3366 20.7791 12.9216 19.7161 12.9906C18.5303 12.9383 17.389 13.4724 16.6279 14.4356L15.8765 13.2111H14.0312V23.8027H16.7018V17.8781C16.6851 17.2574 16.9167 16.658 17.3397 16.2273C17.7626 15.7967 18.3376 15.5746 18.9234 15.6157C19.4929 15.5843 20.0472 15.8153 20.4433 16.2492C20.8394 16.6831 21.0382 17.2773 20.9885 17.8781V23.8027H24.2419V23.4779C23.8995 23.3557 23.6689 23.0161 23.669 22.6338Z"
      fill="#F6F3EE"
    />
    <path
      d="M1.19397 1.36075V10.6228H3.8622V4.80168C3.84572 4.19223 4.07725 3.60382 4.49988 3.18102C4.92252 2.75822 5.49708 2.54023 6.08239 2.58061C6.65142 2.5495 7.20548 2.77626 7.60131 3.20227C7.99715 3.62828 8.19589 4.2117 8.14614 4.80168V10.6207H10.825V4.08969C10.8841 2.98491 10.4859 1.9066 9.7308 1.12658C8.97573 0.346561 7.93584 -0.0607393 6.87327 0.007353C5.68829 -0.0436586 4.54789 0.481083 3.78764 1.42718L3.03204 0.224616H1.19264V0.220465H0.620117V0.538749C0.960426 0.657607 1.19082 0.987628 1.19397 1.36075Z"
      fill="#F6F3EE"
    />
  </svg>
);

export default NanLogo;
